export const productModel = {
  displayName: {
    displayName: 'Display Name',
    inputType: 'text',
  },
  name: {
    displayName: 'Product Name',
    inputType: 'text',
  },
  parameters: {
    displayName: 'Parameters',
    inputType: 'parameters',
  },
  preloaded: {
    displayName: 'Preloaded Model',
    inputType: 'checkbox',
  },
  quote: {
    displayName: 'Quote',
    inputType: 'fileSelect',
  },
  refImage: {
    displayName: 'Reference Image Url',
    inputType: 'firebaseStorage',
  },
  saveToBucket: {
    displayName: 'Save Bucket',
    inputType: 'bucketSelect',
  },
  tempBucket: {
    displayName: 'Temporary Bucket',
    inputType: 'bucketSelect',
  },
  thumbnailImage: {
    displayName: 'Thumbnail Image Url',
    inputType: 'firebaseStorage',
  },
  version: {
    displayName: 'Version',
    inputType: 'text',
  },
  viewable: {
    displayName: 'Viewable Zip File',
    inputType: 'fileSelect',
  },
  zipFile: {
    drawingFileName: {
      displayName: 'Drawing File Path',
      inputType: 'text',
    },
    file: {
      displayName: 'Input File Zip Name',
      inputType: 'fileSelect',
    },
    projectFile: {
      displayName: 'Project File',
      inputType: 'text',
    },
    rootFileName: {
      displayName: 'Root File Name',
      inputType: 'text',
    },
    displayName: 'Zip File Details',
  },
};
